import React from "react";
import { Button, Flex } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { SPACING } from "~/styles/variables";
import StateTemplate from "./StateTemplate";

type Props = {
  gpEntityOverviewUrl: string;
  entityName: string;
  onExit: () => void;
  arenaName: string;
  isTransfers?: boolean;
};
const FinishedState = ({
  onExit,
  entityName,
  gpEntityOverviewUrl,
  arenaName,
  isTransfers,
}: Props) => {
  const handleClick = () => {
    if (isTransfers) {
      window.open(gpEntityOverviewUrl, "_blank");
    } else {
      window.location.replace(gpEntityOverviewUrl);
    }
  };

  const subTitle = `Note this may take up to a couple of minutes to process and show up in ${arenaName}’s Juniper Square workspace. To check the sync status, please go back to ${
    isTransfers ? "transfers" : "the entities list"
  } or navigate to ${entityName} to view the transaction updates once the sync is complete.`;

  return (
    <StateTemplate
      title="Sync in progress..."
      subTitle={subTitle}
      icon={<Icon type="upload" size="xx-large" />}
    >
      <Flex>
        <Button css={{ marginRight: SPACING.SMALL }} variant="neutral" onClick={onExit}>
          {isTransfers ? "Back to transfers" : "Back to entities"}
        </Button>
        <Button
          iconPosition="right"
          icon="external-link"
          css={{ marginLeft: SPACING.SMALL }}
          onClick={handleClick}
        >
          {`Go to ${entityName}`}
        </Button>
      </Flex>
    </StateTemplate>
  );
};

export default FinishedState;
